export default __webpack_public_path__ + "static/steven-frostwick-on-a-train-0f2c3fca0e4def9d12e6ef4da50b796e.jpg";